<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-8">
                <div class="row">
                    <div class="col-lg-3 col-md-6">
                        <div class="d-flex align-items-center">
                            <div>
                                <h3>
                                    <trade-status :status="trade.trade_status"></trade-status>
                                </h3>
                                <span>Status</span>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-6">
                        <div class="d-flex align-items-center">
                            <div>
                                <h3 class="font-medium m-b-0">{{trade.seller_first_name + ' ' + trade.seller_last_name}}</h3>
                                <span>Seller</span>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-6">
                        <div class="d-flex align-items-center">
                            <div>
                                <h3 class="font-medium m-b-0">{{trade.buyer_first_name + ' ' + trade.buyer_last_name}}</h3>
                                <span>Buyer</span>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-6 text-right">
                        <div class="ml-auto">
                            <div>
                                <h3 class="font-medium text-right m-b-0">{{trade.contract_type || '-' | capitalize}}</h3>
                                <span class="text-right">Contract</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row m-t-25">
            <div class="col-md-8">
                <trade-overview :events="events" :trade="trade"></trade-overview>
                <trade-contracts :events="events" :trade="trade"></trade-contracts>
                <trade-provenance :events="events" :trade="trade"></trade-provenance>
                <trade-documents :events="events" :trade="trade" :tradeid="tradeid"></trade-documents>
                <trade-negotiations :events="events" :trade="trade" :tradeid="tradeid"></trade-negotiations>
            </div>
            <!--timeline-->
            <div class="col-md-4">
                <buyer-sidebar :events="events" :trade="trade" v-if="isBuyer()"></buyer-sidebar>
                <seller-sidebar :events="events" :trade="trade" v-if="isSeller()"></seller-sidebar>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from "vue";
    import {mapGetters} from "vuex";
    import TradeStatus from "./TradeStatus";
    import BuyerSidebar from "./sections/sidebar/BuyerSidebar";
    import SellerSidebar from "./sections/sidebar/SellerSidebar";
    import TradeOverview from "./sections/TradeOverview";
    import TradeContracts from "./sections/TradeContracts";
    import TradeDocuments from "./sections/TradeDocuments";
    import TradeProvenance from "./sections/TradeProvenance";
    import TradeShipments from "./sections/TradeShipments";
    import TradeNegotiations from "./sections/TradeNegotiations";
    import Money from "../../../../models/Money";

    export default {
        name: "ViewTrade",
        props: ["tradeid"],
        components: {TradeStatus, SellerSidebar, BuyerSidebar, TradeOverview, TradeContracts, TradeDocuments, TradeProvenance, TradeShipments, TradeNegotiations},
        data() {
            return {
                events: new Vue(),
                trade: {
                    buyer_first_name: '',
                    buyer_id: '',
                    buyer_last_name: '',
                    category: '',
                    commodity_name: '',
                    commodity_props: {},
                    currency: '',
                    description: '',
                    escrow_contract: null,
                    escrow_hash: '',
                    offer_created_at: '',
                    offer_expires_at: '',
                    offer_id: '',
                    offer_owner: '',
                    offer_status: '',
                    pricing_type: '',
                    quantity: '',
                    seller_first_name: '',
                    seller_id: '',
                    seller_last_name: '',
                    total_amount: null,
                    trade_contract: null,
                    trade_created_at: '',
                    trade_hash: '',
                    trade_id: '',
                    trade_props: {},
                    trade_status: '',
                    type: '',
                    unit_price: '',
                    unit: {
                        id: null,
                        name: '',
                        symbol: '',
                        base_unit: ''
                    },
                    payment_contract: null,
                    payment_hash: '',
                },
                attachments: [],
                file: File,
                filename: "No File Chosen",
                noOfAttachments: 0,
                message: '',
                conversation: []
            }
        },
        computed: {
            ...mapGetters(["currentUser"])
        },
        created() {
            this.events.$on('trade:reload', this.reloadComponent);
        },
        beforeMount() {
            this.getTrade();
            this.$root.$on('refreshTrade', () => {
                this.getTrade()
            })
        },
        methods: {
            async getTrade() {
                try {
                    $(".preloader").fadeIn();
                    let reply  = await this.$http.get("/trades/" + this.tradeid);
                    $(".preloader").fadeOut();
                    this.trade = reply.data && reply.data.length > 0 ? reply.data[0] : {};

                    this.trade.unit_price   = new Money(this.trade.unit_price);
                    this.trade.total_amount = new Money(this.trade.total_amount);
                } catch(err) {
                    $(".preloader").fadeOut();
                    console.log(err);
                }
            },
            reloadComponent() {
                this.getTrade();
            },
            isSeller() {
                return this.trade.seller_id === this.currentUser.id;
            },
            isBuyer() {
                return this.trade.buyer_id === this.currentUser.id;
            }
        }
    };
</script>

<style scoped>

</style>
